export default "__VITE_ASSET__Btaa5pVC__"